<template>
    <Suspense>
        <div>
            <RouterView />
            <PopUp />
            <LanguageSelector />
            <CookiesBanner />
        </div>
    </Suspense>
</template>
<script setup>
import CookiesBanner from '@/js/components/CookiesBanner.vue';
import PopUp from '@/js/components/dashboard/InfoPopUp.vue';
import LanguageSelector from '@/js/components/LanguageSelector.vue';
</script>
<style lang="scss" scoped></style>
